module.exports = __webpack_public_path__ + "@/assets/img/footer-onmex.8f8ddd7e.png";